/*
* HoC that off-loads query meta data handling like loading and errors.
 */
import React from 'react';
import { compose, branch, renderComponent } from 'recompose';

const LoadingSpinner = (props) => {
  return (
    <div className="center-block">Loading ...</div>
  );
};

const withLoadingSpinner = branch(
  (props) => {
    if (props.data.loading) {
      return true;
    }

    // This is to accommodate https://github.com/apollographql/react-apollo/issues/1314
    // Even though data is in fact loading, the loading attribute is set to false.
    //
    // for current version of apollo, 10 attributes exist without any data loaded
    // this test assumes that apollo only triggers calls that eventually result in
    // data or an error. When data is loaded, it should have 10+ attributes
    const sizeOfData = Object.keys(props.data).length;
    if (sizeOfData === 10) {
      return true;
    }

    return false;
  },
  renderComponent(LoadingSpinner),
);

const ErrorAlert = (props) => {
  return (
    <div>Error ...</div>
  );
};

const withErrorAlert = branch(
  (props) => { return !!props.data.error; },
  renderComponent(ErrorAlert),
);

const queryMetaHandler = compose(
  withErrorAlert,
  withLoadingSpinner,
);

export default queryMetaHandler;
